/**
 *数组拆分
 * @param {Array==拆分数组} array
 * @param {Number==拆分条数} subGroupLength
 * @returns
 */
function group(array, subGroupLength) {
  let index = 0;
  let newArray = [];
  while(index < array.length) {
      newArray.push(array.slice(index, index += subGroupLength));
  }
  return newArray;
};
module.exports={
  group
}


// WEBPACK FOOTER //
// ./src/common/public.js